export const comments_3374312 = {"data":{"data":[],"links":{}}}